import React, { useState } from 'react';

const EC = {
  disponible:{fill:'#0055a5',hover:'#003d7a'},
  vendido:   {fill:'#94a3b8',hover:'#64748b'},
  reservado: {fill:'#f97316',hover:'#ea6c0a'},
};

const INFO_109 = {
  1:  {n:1, s:600.00, p:null,  d:'Vista al Mar',    e:'vendido'},
  2:  {n:2, s:600.00, p:52000, d:'Vista al Mar',    e:'disponible'},
  3:  {n:3, s:600.00, p:52000, d:'Vista al Mar',    e:'disponible'},
  4:  {n:4, s:600.00, p:null,  d:'Vista al Mar',    e:'vendido'},
  5:  {n:5, s:600.00, p:52000, d:'Vista al Mar',    e:'disponible'},
  6:  {n:6, s:600.00, p:52000, d:'Vista al Mar',    e:'disponible'},
  7:  {n:7, s:null,   p:null,  d:'Vista al Mar',    e:'vendido'},
  8:  {n:8, s:null,   p:null,  d:'Vista al Mar',    e:'vendido'},
  9:  {n:9, s:null,   p:null,  d:'Vista al Mar',    e:'vendido'},
  10: {n:10,s:457.04, p:45000, d:'Vista al Mar',    e:'disponible'},
  11: {n:11,s:424.19, p:45000, d:'Vista al Mar',    e:'disponible'},
  12: {n:12,s:529.58, p:48000, d:'Vista al Mar',    e:'disponible'},
  13: {n:13,s:406.88, p:45500, d:'Vista al Mar',    e:'disponible'},
  14: {n:14,s:399.87, p:45500, d:'Vista al Mar',    e:'disponible'},
  15: {n:15,s:328.66, p:40000, d:'Vista al Mar',    e:'disponible'},
  16: {n:16,s:305.22, p:40000, d:'Vista al Mar',    e:'disponible'},
  17: {n:17,s:305.22, p:40000, d:'Vista al Mar',    e:'disponible'},
  18: {n:18,s:305.22, p:40000, d:'Vista al Mar',    e:'disponible'},
  19: {n:19,s:301.67, p:40000, d:'Vista al Mar',    e:'disponible'},
  20: {n:20,s:300.64, p:40000, d:'Vista al Mar',    e:'disponible'},
  21: {n:21,s:303.96, p:24000, d:'Alejado del Mar', e:'disponible'},
  22: {n:22,s:334.38, p:null,  d:'Alejado del Mar', e:'vendido'},
  23: {n:23,s:301.67, p:null,  d:'Alejado del Mar', e:'vendido'},
  24: {n:24,s:null,   p:null,  d:'Alejado del Mar', e:'vendido'},
  25: {n:25,s:null,   p:null,  d:'Alejado del Mar', e:'vendido'},
  26: {n:26,s:305.22, p:null,  d:'Alejado del Mar', e:'vendido'},
  27: {n:27,s:305.22, p:null,  d:'Alejado del Mar', e:'vendido'},
  28: {n:28,s:396.34, p:26000, d:'Primera Fila',    e:'disponible'},
  29: {n:29,s:396.34, p:26000, d:'Primera Fila',    e:'disponible'},
  30: {n:30,s:623.43, p:34000, d:'Primera Fila',    e:'disponible'},
  31: {n:31,s:705.09, p:36000, d:'Primera Fila',    e:'disponible'},
  32: {n:32,s:471.72, p:34000, d:'Primera Fila',    e:'disponible'},
  33: {n:33,s:471.72, p:34000, d:'Primera Fila',    e:'disponible'},
  34: {n:34,s:471.72, p:34000, d:'Primera Fila',    e:'disponible'},
  35: {n:35,s:471.72, p:34000, d:'Primera Fila',    e:'disponible'},
  36: {n:36,s:439.26, p:33000, d:'Primera Fila',    e:'disponible'},
  37: {n:37,s:331.53, p:31000, d:'Primera Fila',    e:'disponible'},
  38: {n:38,s:325.84, p:36000, d:'Primera Fila',    e:'disponible'},
};

function Modal({lote, onClose, onConsultar}) {
  React.useEffect(() => {
    const h = e => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', h);
    return () => window.removeEventListener('keydown', h);
  }, [onClose]);
  return (
    <div className='fixed inset-0 z-[200] flex items-center justify-center p-4'
      style={{backgroundColor:'rgba(0,0,0,0.6)',backdropFilter:'blur(6px)'}} onClick={onClose}>
      <div className='bg-white rounded-3xl shadow-2xl w-full max-w-sm overflow-hidden'
        style={{animation:'popIn 0.28s cubic-bezier(0.34,1.56,0.64,1) both'}} onClick={e=>e.stopPropagation()}>
        <div className='bg-[#0055a5] px-7 py-5 text-white relative'>
          <button onClick={onClose} className='absolute top-3 right-4 text-2xl font-bold opacity-50 hover:opacity-100'>x</button>
          <p className='text-[10px] uppercase tracking-[0.3em] opacity-60 mb-1'>Manzana 109</p>
          <h3 className='text-3xl font-black'>Parcela {lote.n}</h3>
          <span className='inline-block mt-2 text-[10px] font-black uppercase px-3 py-1 rounded-full bg-white/20'>
            {lote.e==='disponible'?'Disponible':lote.e==='reservado'?'Reservado':'Vendido'}
          </span>
        </div>
        <div className='p-5 grid grid-cols-2 gap-3'>
          <div className='bg-slate-50 rounded-2xl p-4'>
            <p className='text-[10px] uppercase tracking-widest text-slate-400 font-bold mb-1'>Superficie</p>
            <p className='text-2xl font-black text-slate-800'>{lote.s ? `${lote.s}` : '-'}<span className='text-sm font-normal text-slate-400'> m²</span></p>
          </div>
          <div className='bg-slate-50 rounded-2xl p-4'>
            <p className='text-[10px] uppercase tracking-widest text-slate-400 font-bold mb-1'>Precio</p>
            <p className='text-xl font-black' style={{color:lote.e==='disponible'?'#0055a5':'#94a3b8'}}>
              {lote.e==='disponible'&&lote.p ? 'USD '+lote.p.toLocaleString() : <span className='text-base'>-</span>}
            </p>
          </div>
          <div className='bg-slate-50 rounded-2xl p-4 col-span-2'>
            <p className='text-[10px] uppercase tracking-widest text-slate-400 font-bold mb-1'>Ubicación</p>
            <p className='text-base font-semibold text-slate-700'>{lote.d}</p>
          </div>
        </div>
        <div className='px-5 pb-5'>
          {lote.e==='disponible'
            ? <button onClick={onConsultar} className='w-full bg-[#0055a5] text-white py-4 rounded-2xl font-black uppercase tracking-widest text-sm hover:bg-blue-700 active:scale-95 transition-all'>Consultar este lote</button>
            : <p className='text-center text-slate-400 text-sm py-2'>{lote.e==='vendido'?'Este lote fue vendido.':'Este lote está reservado.'}</p>}
        </div>
      </div>
      <style>{'@keyframes popIn{from{opacity:0;transform:scale(0.8) translateY(20px)}to{opacity:1;transform:scale(1) translateY(0)}}'}</style>
    </div>
  );
}

function getCentroid109(pts) {
  const coords = pts.trim().replace(/,/g, ' ').split(/\s+/).map(Number).filter(n => !isNaN(n));
  let x = 0, y = 0;
  const count = coords.length / 2;
  for (let i = 0; i < coords.length; i += 2) { x += coords[i]; y += coords[i+1]; }
  return [x / count, y / count];
}

function Parcel({id, points, d, num, hov, setHov, onClick}) {
  const lote = INFO_109[num];
  if (!lote) return null;
  const fill = hov === id ? EC[lote.e].hover : EC[lote.e].fill;
  const isClickable = lote.e !== 'vendido';
  const shapeProps = {
    id, fill, stroke:'white', strokeWidth:2,
    style: isClickable ? {cursor:'pointer'} : {},
    onMouseEnter: isClickable ? ()=>setHov(id) : undefined,
    onMouseLeave: isClickable ? ()=>setHov(null) : undefined,
    onClick: isClickable ? ()=>onClick(lote) : undefined,
  };
  if (points) return <polygon {...shapeProps} points={points}/>;
  if (d) return <path {...shapeProps} d={d} fill={fill}/>;
  return null;
}

export default function Manzana109SVG() {
  const [hov, setHov] = useState(null);
  const [modal, setModal] = useState(null);

  const handleConsultar = () => {
    if (modal) {
      window.dispatchEvent(new CustomEvent('seleccionarLote', {
        detail: { manzana: '109', lote: modal.n }
      }));
    }
    setModal(null);
    setTimeout(() => document.getElementById('contacto')?.scrollIntoView({behavior:'smooth'}), 150);
  };
  const disp = Object.values(INFO_109).filter(l=>l.e==='disponible').length;
  const res  = Object.values(INFO_109).filter(l=>l.e==='reservado').length;
  const vend = Object.values(INFO_109).filter(l=>l.e==='vendido').length;

  return (
    <div>
      <div className='mb-4'>
        <div className='flex flex-wrap items-center gap-3 mb-1'>
          <h3 className='text-lg font-black text-[#0055a5] uppercase tracking-wide'>Manzana 109 - Barrancas</h3>
          <span className='text-xs font-bold px-3 py-1 rounded-full bg-blue-50 text-[#0055a5]'>{disp} disponibles</span>
          {res>0 && <span className='text-xs font-bold px-3 py-1 rounded-full bg-orange-50 text-orange-500'>{res} reservados</span>}
          <span className='text-xs font-bold px-3 py-1 rounded-full bg-slate-100 text-slate-500'>{vend} vendidos</span>
        </div>
        <p className='text-sm text-slate-400'>Hacé click en cualquier lote para ver los detalles.</p>
      </div>
      <div className='flex flex-wrap gap-4 mb-4'>
        {[['disponible','#0055a5'],['reservado','#f97316'],['vendido','#94a3b8']].map(([k,c])=>(
          <div key={k} className='flex items-center gap-2'>
            <span className='w-3.5 h-3.5 rounded-sm' style={{backgroundColor:c,display:'inline-block'}}/>
            <span className='text-xs font-semibold text-slate-500 capitalize'>{k}</span>
          </div>
        ))}
      </div>
      <div className='bg-[#f8fafc] rounded-2xl border border-stone-100 overflow-hidden p-2'>
        <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 820 1100' className='w-full h-auto' style={{maxHeight:580}}>
          <Parcel id='109-1'  num={1}  points='478.23 260.67 580.58 157.66 595.87 159.65 621.12 225.45 485.54 278.61 478.23 260.67' hov={hov} setHov={setHov} onClick={setModal}/>
          <Parcel id='109-2'  num={2}  points='507.22 328.46 487.29 280.61 622.86 227.44 641.47 278.61 507.22 328.46' hov={hov} setHov={setHov} onClick={setModal}/>
          <Parcel id='109-3'  num={3}  points='526.50 377.64 507.22 328.46 641.47 278.61 660.08 327.79 526.50 377.64' hov={hov} setHov={setHov} onClick={setModal}/>
          <Parcel id='109-4'  num={4}  points='547.10 433.46 526.50 377.64 660.08 327.79 681.35 382.95 547.10 433.46' hov={hov} setHov={setHov} onClick={setModal}/>
          <Parcel id='109-5'  num={5}  points='565.71 484.63 547.10 433.46 681.35 382.95 699.95 431.47 565.71 484.63' hov={hov} setHov={setHov} onClick={setModal}/>
          <Parcel id='109-6'  num={6}  points='584.32 535.14 565.71 484.63 699.95 431.47 719.23 484.63 584.32 535.14' hov={hov} setHov={setHov} onClick={setModal}/>
          <Parcel id='109-7'  num={7}  points='603.59 587.65 584.32 535.14 719.23 484.63 737.84 540.46 603.59 587.65' hov={hov} setHov={setHov} onClick={setModal}/>
          <Parcel id='109-8'  num={8}  points='611.56 611.57 602.92 585.65 737.84 540.46 758.44 587.65 636.82 636.16 611.56 611.57' hov={hov} setHov={setHov} onClick={setModal}/>
          <Parcel id='109-9'  num={9}  d='M746.98,650.16c11.90-2.07,23.68-2.50,35.09-1.47l-23.63-61.05-121.62,48.51,44.76,45.41c17.55-15.71,39.96-26.98,65.40-31.41Z' hov={hov} setHov={setHov} onClick={setModal}/>
          <Parcel id='109-10' num={10} d='M681.57,681.58l-70.01-70.01-39.10,66.20,81.90,38.69c6.77-13.02,16.00-24.85,27.21-34.89Z' hov={hov} setHov={setHov} onClick={setModal}/>
          <Parcel id='109-11' num={11} d='M654.37,716.46l-81.90-38.69-29.09,71.75,98.65,7.69c1.50-14.31,5.76-28.09,12.34-40.75Z' hov={hov} setHov={setHov} onClick={setModal}/>
          <Parcel id='109-12' num={12} d='M641.49,764.83l-.50-8.84-97.61-6.46-2.59,9.05-37.49,33.61,29.74,26.50,110.54-17.45-.91-15.96c-1.03-6.87-1.41-13.71-1.17-20.45Z' hov={hov} setHov={setHov} onClick={setModal}/>
          <Parcel id='109-13' num={13} d='M654.26,828.71c-.23-1.08-.55-2.13-.96-3.16l-9.73-24.32-110.54,17.45,51.07,52.36,47.83-8.40,15.89-12.81c2.72-2.19,4.80-5.07,6.02-8.34,1.31-3.49,1.59-7.29.81-10.94l-.39-1.84Z' hov={hov} setHov={setHov} onClick={setModal}/>
          <Parcel id='109-14' num={14} points='584.10 871.05 516.10 887.65 465.10 834.10 503.30 792.19 584.10 871.05' hov={hov} setHov={setHov} onClick={setModal}/>
          <Parcel id='109-15' num={15} points='517.80 887.65 499.53 891.48 475.30 906.35 412.40 843.03 443.00 812.00 517.80 887.65' hov={hov} setHov={setHov} onClick={setModal}/>
          <Parcel id='109-16' num={16} points='475.30 906.35 440.03 939.92 379.68 878.30 412.40 843.03 475.30 906.35' hov={hov} setHov={setHov} onClick={setModal}/>
          <Parcel id='109-17' num={17} points='440.03 939.92 409.85 972.22 346.95 909.33 379.68 877.03 440.03 939.92' hov={hov} setHov={setHov} onClick={setModal}/>
          <Parcel id='109-18' num={18} points='346.53 908.05 409.85 972.22 375.43 1004.10 315.08 940.77 346.53 908.05' hov={hov} setHov={setHov} onClick={setModal}/>
          <Parcel id='109-19' num={19} points='376.70 1003.67 315.08 940.77 281.93 972.65 343.98 1038.10 376.70 1003.67' hov={hov} setHov={setHov} onClick={setModal}/>
          <Parcel id='109-20' num={20} points='292.40 1066.15 317.56 1064.36 343.98 1036.65 296.17 985.25 249.63 1033.52 292.40 1066.15' hov={hov} setHov={setHov} onClick={setModal}/>
          <Parcel id='109-21' num={21} points='248.35 1035.12 297.23 989.22 256.85 950.97 202.03 1003.67 248.35 1035.12' hov={hov} setHov={setHov} onClick={setModal}/>
          <Parcel id='109-22' num={22} points='165.90 963.30 168.45 982.85 202.03 1003.67 257.28 949.70 219.03 912.30 165.90 963.30' hov={hov} setHov={setHov} onClick={setModal}/>
          <Parcel id='109-23' num={23} points='219.03 912.30 281.93 972.65 315.08 940.77 250.48 878.73 219.03 912.30' hov={hov} setHov={setHov} onClick={setModal}/>
          <Parcel id='109-24' num={24} points='250.48 878.73 315.08 940.77 346.53 908.05 282.78 846.43 250.48 878.73' hov={hov} setHov={setHov} onClick={setModal}/>
          <Parcel id='109-25' num={25} points='282.78 846.43 346.95 909.33 379.68 877.03 315.50 813.28 282.78 846.43' hov={hov} setHov={setHov} onClick={setModal}/>
          <Parcel id='109-26' num={26} points='315.50 813.28 379.68 877.03 411.13 843.03 348.65 779.28 315.50 813.28' hov={hov} setHov={setHov} onClick={setModal}/>
          <Parcel id='109-27' num={27} points='348.65 779.28 411.13 843.03 443.00 812.00 380.95 748.68 348.65 779.28' hov={hov} setHov={setHov} onClick={setModal}/>
          <Parcel id='109-28' num={28} points='380.95 748.68 465.10 834.10 495.70 800.10 411.55 716.38 380.95 748.68' hov={hov} setHov={setHov} onClick={setModal}/>
          <Parcel id='109-29' num={29} points='411.55 716.38 495.70 800.10 524.60 772.90 441.73 687.05 411.55 716.38' hov={hov} setHov={setHov} onClick={setModal}/>
          <Parcel id='109-30' num={30} points='441.73 687.05 524.18 771.20 540.79 758.57 572.47 677.77 467.23 654.33 465.95 664.95 441.73 687.05' hov={hov} setHov={setHov} onClick={setModal}/>
          <Parcel id='109-31' num={31} points='467.23 654.33 572.47 677.77 611.56 611.57 595.58 568.90 460.00 620.33 469.78 638.18 467.23 654.33' hov={hov} setHov={setHov} onClick={setModal}/>
          <Parcel id='109-32' num={32} points='461.28 619.05 595.58 567.27 581.55 523.84 446.83 576.93 461.28 619.05' hov={hov} setHov={setHov} onClick={setModal}/>
          <Parcel id='109-33' num={33} points='446.83 578.25 581.55 526.83 565.71 484.63 430.68 536.60 446.83 578.25' hov={hov} setHov={setHov} onClick={setModal}/>
          <Parcel id='109-34' num={34} points='430.68 536.60 565.71 484.63 549.68 442.68 415.38 494.10 430.68 536.60' hov={hov} setHov={setHov} onClick={setModal}/>
          <Parcel id='109-35' num={35} points='415.38 494.10 549.68 442.68 535.23 401.88 400.08 454.15 415.38 494.10' hov={hov} setHov={setHov} onClick={setModal}/>
          <Parcel id='109-36' num={36} points='390.73 429.08 400.08 454.15 535.23 401.88 519.93 363.63 407.30 406.13 390.73 429.08' hov={hov} setHov={setHov} onClick={setModal}/>
          <Parcel id='109-37' num={37} points='503.90 323.14 521.20 364.48 407.30 406.13 418.83 354.38 503.90 323.14' hov={hov} setHov={setHov} onClick={setModal}/>
          <Parcel id='109-38' num={38} points='409.53 331.80 418.78 354.38 503.30 322.22 479.53 259.95 409.53 331.80' hov={hov} setHov={setHov} onClick={setModal}/>
        </svg>
      </div>
      {modal && <Modal lote={modal} onClose={()=>setModal(null)} onConsultar={handleConsultar}/>}
    </div>
  );
}
